// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d63e7c4","453":"3edc667e","732":"5eb0a2af"}[chunkId] + ".chunk.js";
};